import { render, staticRenderFns } from "./CompareFlightLeg.vue?vue&type=template&id=72599fd2"
import script from "./CompareFlightLeg.vue?vue&type=script&lang=js"
export * from "./CompareFlightLeg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports